import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative">
      <Header />
      <main>
        <Hero />
        <AppSection />
        <AboutSection />
        <RankingSection />
        <FeaturesSection />
        <TopicsSection />
        <FaqSection />
        <MediaSection />
        <IndexSection />
        <CarouselSection />
        <CardsSection />
        <CommentsSection />
        <ContactSection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}